// Port of api/fuel/app/classes/constants.php
// Application-level constants.

export default {

	// Sync status state machine
	SYNC_STATUS_PENDING: 0,
	SYNC_STATUS_IDLE: 1,
	SYNC_STATUS_PROCESSING: 2,
	SYNC_STATUS_COMPLETE: 3,
	SYNC_STATUS_COMPLETED: 3,
	SYNC_STATUS_QUEUEING: 4,

	// Sync priorities (higher = higher priority)
	SYNC_PRIORITY_USER_EXISTS: 100,
	SYNC_PRIORITY_USER_SELF: 80,
	SYNC_PRIORITY_USER_LIVE: 90,
	SYNC_PRIORITY_USER_ADD: 70,
	SYNC_PRIORITY_ACTION: 75,
	SYNC_PRIORITY_USER_AUTO_UPGRADE: 65,
	SYNC_PRIORITY_USER_AUTO: 60,
	SYNC_PRIORITY_GROUP: 63,
	SYNC_PRIORITY_GAMES_NEW: 35,
	SYNC_PRIORITY_GAMES: 30,
	SYNC_PRIORITY_VERSIONS: 20,
	SYNC_PRIORITY_SALE: 11,
	SYNC_PRIORITY_SALES: 10,
	SYNC_PRIORITY_BUDDIES: 0,

	// Platform voting feature statuses
	PLATFORM_VOTING_ACTIVE: 1,
	PLATFORM_VOTING_WINNER: 2,

	// Collection status field constants
	COLLECTION_STATUS_OWN: 1,
	COLLECTION_STATUS_PREVOWNED: 2,
	COLLECTION_STATUS_FORTRADE: 3,
	COLLECTION_STATUS_WANT: 4,
	COLLECTION_STATUS_WANTTOPLAY: 5,
	COLLECTION_STATUS_WANTTOBUY: 6,
	COLLECTION_STATUS_WISHLIST: 7,
	COLLECTION_STATUS_PREORDERED: 8,
	COLLECTION_STATUS_HASPARTS: 9,
	COLLECTION_STATUS_WANTPARTS: 10,

	// Collection nesting state
	NESTED_NONE: 0,
	NESTED_OFFICIAL: 1,
	NESTED_CUSTOM: 2,

	// Group types and membership
	GROUP_TYPE_STANDARD: 1,
	GROUP_MEMBERSHIP_OPEN: 1,
	GROUP_MEMBERSHIP_CLOSED: 2,

	// Tag contexts
	TAG_CONTEXT_GAME: 0,
	TAG_CONTEXT_COLLECTION: 1,
	TAG_CONTEXT_RATING: 2,
	TAG_CONTEXT_PLAY: 3,
	TAG_CONTEXT_GAMEPLAY: 4,

	// API error codes
	API_STATUS_OK: 1,
	API_STATUS_ERROR: 2,
	API_ERROR_USER_INVALID: 100,
	API_ERROR_USER_NOTFOUND: 101,
	API_ERROR_USER_REGISTERED: 102,
	API_ERROR_USER_INGROUP: 103,
	API_ERROR_USER_NOTINGROUP: 104,
	API_ERROR_USER_NOBUDDIES: 105,
	API_ERROR_RESPONSE_INVALID: 106,
	API_ERROR_RESPONSE_THROTTLED: 107,
	API_ERROR_RESPONSE_QUEUED: 108,
	API_ERROR_UNKNOWN: 109,
	API_ERROR_USER_KEY_INVALID: 110,
	API_ERROR_USER_ALREADY_LOGGEDIN: 111,
	API_ERROR_USER_ALREADY_LOGGEDOUT: 112,
	API_ERROR_GROUP_NOTFOUND: 113,
	API_ERROR_SYNC_NOTALLOWED: 114,
	API_ERROR_SYNC_REQUIRED: 115,
	API_ERROR_UNAUTHORISED: 116,
	API_ERROR_INVALID: 117,
	API_ERROR_GROUP_SLUG_TAKEN: 118,
	API_ERROR_USER_NOTREGISTERED: 119,
	API_ERROR_LIST_NOTFOUND: 120,
	API_ERROR_LIST_EDITION_NOTFOUND: 121,
	API_ERROR_SYNC_INPROGRESS: 122,
	API_ERROR_NOTFOUND: 123,
	API_ERROR_USER_INCORRECT: 124,
	API_ERROR_SYNC_FAIL: 125,
	API_ERROR_SYNC_UNAUTHORISED: 126,

	// User upgrade tiers
	USER_UPGRADE_LEGACY: 1,
	USER_UPGRADE_SUPPORTER: 2,
	USER_UPGRADE_FREE: 0,
	USER_UPGRADE_POWER: 3,
	USER_UPGRADE_GROUP: 4,

	// Time constants (seconds)
	TIME_HOUR: 3600,
	TIME_DAY: 86400,
	TIME_WEEK: 604800,
	TIME_MONTH: 2592000,
	TIME_YEAR: 31536000,

	// API build (for cache busting)
	API_BUILD: 'offline',

	// Owner / entity types
	TYPE_USER: 1,
	TYPE_GROUP: 2,
	TYPE_BUDDIES: 3,

	// Collection types
	COLLECTION_TYPE_USER: 1,
	COLLECTION_TYPE_GROUP: 2,

	// Game types
	GAME_TYPE_BASE: 1,
	GAME_TYPE_EXPANSION: 2,

	// Insight types
	INSIGHT_TYPE_USER_COLLECTION: 1,
	INSIGHT_TYPE_GAME_VALUE: 2,
	INSIGHT_TYPE_GAME_VERSION_VALUE: 3,
	INSIGHT_TYPE_USER_SYNC: 4,
	INSIGHT_TYPE_MEMBERS_SIZE: 7,
	INSIGHT_TYPE_MEMBERS_ADDED: 8,
	INSIGHT_TYPE_MEMBERS_REMOVED: 9,
	INSIGHT_TYPE_COLLECTION_SIZE: 1,
	INSIGHT_TYPE_COLLECTION_ADDED: 2,
	INSIGHT_TYPE_COLLECTION_REMOVED: 3,
	INSIGHT_TYPE_RATINGS_COUNT: 4,
	INSIGHT_TYPE_RATINGS_ADDED: 5,
	INSIGHT_TYPE_RATINGS_UPDATED: 6,

	// Insight periods
	INSIGHT_PERIOD_DAY: 1,
	INSIGHT_PERIOD_MONTH: 2,
	INSIGHT_PERIOD_YEAR: 3,

	// Log types
	LOG_TYPE_ACCOUNT_VIEWED: 1,
	LOG_TYPE_USER_RATING: 2,
	LOG_TYPE_USER_COLLECTION: 3,
	LOG_TYPE_USER_INITIATED: 4,
	LOG_TYPE_USER_REGISTERED: 5,
	LOG_TYPE_USER_PLAY: 6,
	LOG_TYPE_USER_GROUP: 7,
	LOG_TYPE_USER_MEMBER: 8,
	LOG_TYPE_USER_HINDEX: 9,
	LOG_TYPE_USER_LIST: 10,
	LOG_TYPE_USER_EDITION: 11,
	LOG_TYPE_USER_COMMENT: 12,
	LOG_TYPE_USER_BUDDY: 13,
	LOG_TYPE_USER_BUDDIES: 14,
	LOG_TYPE_USER_COLLECTION_STATUS: 15,
	LOG_TYPE_USER_TAG: 20,
	LOG_TYPE_USER_TAG_ATTACH: 21,

	// Log contexts
	LOG_CONTEXT_ADDED: 1,
	LOG_CONTEXT_CREATED: 1,
	LOG_CONTEXT_UPDATED: 2,
	LOG_CONTEXT_REMOVED: 3,
	LOG_CONTEXT_DELETED: 3

}
